/**
 * @desc 获取单店铺退货列表
 */
const URL = "/rantion-walmart";
import http, { updateResponse } from "@/http";
export function request(shopCode: string, body: defs.walmart.ReturnsRequest, options?: any) {
  return updateResponse(
    http(URL + `/walmart/walmartOrderReturns/getReturns/${shopCode}`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
